// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__15xzr","description":"PatientConsentPreview_description__2rNK5"};